import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import {
  amber,
  blue,
  cyan,
  deepOrange,
  deepPurple,
  grey,
  indigo,
  lightBlue,
  orange,
  pink,
  purple,
  red,
  teal,
  yellow,
} from '@mui/material/colors'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import ExceptionIcon from 'components/exceptions/ExceptionIcon'
import { EXCEPTION_TYPES } from 'settings/constants/exceptions'
import { ALPHA_38_PERCENT } from 'theme/colors'
import { normalizeCasing } from 'utils/string'

const {
  Contamination,
  Damage,
  Delay,
  Extra,
  'Extra Item': ExtraItem,
  'No Access': NoAccess,
  'No Payment': NoPayment,
  'Not Out': NotOut,
  Overloaded,
  Photo,
  Safety,
  'Service Review': ServiceReview,
  Special,
  Weight,
  Sign,
  Color,
  Size,
} = EXCEPTION_TYPES
export const EXCEPTION_TO_COLOR_MAP: Record<string, string> = {
  [Contamination]: indigo[100],
  [Damage]: orange[100],
  [Delay]: purple[100],
  [Extra]: yellow[100],
  [ExtraItem]: yellow[100],
  [NoAccess]: pink[100],
  [NoPayment]: deepOrange[100],
  [NotOut]: red[100],
  [Overloaded]: amber[100],
  [Photo]: teal[100],
  [Safety]: deepPurple[100],
  [ServiceReview]: blue[100],
  [Special]: grey[100],
  [Weight]: lightBlue[100],
  [Sign]: grey[100],
  [Color]: deepOrange[100],
  [Size]: cyan[100],
}

type Props = {
  exception?: string | null
  label?: string
}

const ExceptionChip: React.FC<Props> = ({ exception, label }) => {
  const theme = useTheme()
  const backgroundColor = exception ? EXCEPTION_TO_COLOR_MAP[exception] : undefined
  return (
    <Chip
      avatar={
        <Avatar sx={{ backgroundColor: `${theme.palette.background.black}${ALPHA_38_PERCENT}` }}>
          <ExceptionIcon exception={exception} sx={{ color: theme.palette.common.white, width: 16, height: 16 }} />
        </Avatar>
      }
      label={label || normalizeCasing(exception ?? '')}
      sx={{ backgroundColor, borderRadius: '4px' }}
    />
  )
}

export default ExceptionChip
